import {BaseIdCodeModel, BaseIdModel, IdCodeNameModel, IdTextModel} from "../base-id.model";
import {GLOBAL} from "../../constants";
import {Type} from "class-transformer";

export class UserInfoModel extends IdCodeNameModel {
  ResourceId: string;
}

export class UserModel extends BaseIdModel {
  Email: string;
  RoleIds: string[];
  @Type(() => IdTextModel)
  Language: IdTextModel;
  LanguageId: string;
  Fullname: string;
  Password: string;
  Privileges: string[];
  TokenVersion?: string;

  get DisplayName(): string {
    return this.Fullname || this.Email;
  }

  static CreateDefault(init?: Partial<UserModel>) {
    return Object.assign(new UserModel(), {} as UserModel, init);
  }


  get IsAdmin(): boolean {
    return this.Privileges?.includes(GLOBAL.Privileges.EditUser);
  }

  get IsSysAdmin(): boolean {
    return this.Privileges?.includes(GLOBAL.Privileges.SystemAdministrator);
  }

  get IsTranslator(): boolean {
    return this.Privileges?.includes(GLOBAL.Privileges.EditLocalization);
  }
}
